export const HEADLINE_VARIANTS = [
  {
    title: "The UK's most trusted weight-loss programme",
    description:
      "Built by dietitians and psychologists, used by the NHS. We've helped 250,000+ form healthy habits to keep the weight off for good.",
    rank: 1,
  },
  {
    title:
      'Effective, safe, trusted. The weight-loss programme chosen by the NHS.',
    description:
      "Built by dietitians and psychologists, we've helped 250,000+ form habits to keep the weight off for good.",
    rank: 2,
  },
  {
    title:
      'Serious about long-term weight loss? Choose the programme GPs trust',
    description:
      "Built by dietitians and psychologists, used by the NHS. We've helped 250,000+ form habits to keep the weight off for good.",
    rank: 3,
  },
  {
    title: 'Safe and effective. A programme chosen by doctors across the UK.',
    description:
      "Built by psychologists, used by the NHS. We've helped 250,000+ form habits to keep the weight off for good.",
    rank: 4,
  },
  {
    title:
      "Lose weight with confidence. The UK's trusted choice for long-term weight loss.",
    description:
      "Built by psychologists, used by the NHS. We've helped 250,000+ form habits to keep the weight off for good.",
    rank: 5,
  },
  {
    title:
      'From PCOS to menopause, our weight-loss programme is tailored to you.',
    description:
      'Built by health experts to address real-life challenges, from hormonal changes to busy schedules. Trusted by 250,000 and used by the NHS.',
    rank: 6,
  },
  {
    title: 'From PCOS to menopause, weight-loss should be tailored to you.',
    description:
      'Built by health experts to address real-life challenges, from hormonal changes to busy schedules. Trusted by 250,000 and used by the NHS.',
    rank: 7,
  },
  {
    title: 'Personalised weight loss that works for you.',
    description:
      'Built by health experts to address real-life challenges, from hormonal changes to busy schedules. Trusted by 250,000 and used by the NHS.',
    rank: 8,
  },
  {
    title:
      'End the diet cycle. Long-term weight loss backed by science, tailored to you.',
    description:
      "Join the programme that's trusted by 250,000+ and used by the NHS.",
    rank: 9,
  },
  {
    title:
      'A weight-loss programme that understands and adapts to your unique health journey.',
    description:
      'Designed by health experts. Recommended by GPs. Used by the NHS.',
    rank: 10,
  },
  // Control variant
  {
    title:
      "One new habit that lasts for a lifetime is worth 100 short-term diets that don't stick.",
    description:
      'By focusing on creating new habits, Second Nature makes weight loss feel easier and last longer.',
    rank: 11,
  },
];
